// @flow

// Action Type
import * as actionTypes from 'store/reducers/appointment/actionTypes';
import * as actionTypesPersonInfo from 'store/reducers/user/personInfo/actions';

// Selectors
import {
  getDealerName,
  getOrgKey
} from 'store/reducers/dealerSettings/selectors';

// types
import type { Store, Action } from 'types/redux';

export const pendoMiddleware = (store: Store) => (
  next: (action: Action) => any
) => (action: any) => {
  switch (action.type) {
    case actionTypes.SET_CUSTOMER_VEHICLE: {
      if (action.payload && action.payload.personId) {
        /* eslint-disable camelcase */
        pendo.identify({
          visitor: {
            id: `${getOrgKey(store.getState())}_${action.payload.personId}`
          },
          account: {
            id: 'xtm_' + getOrgKey(store.getState()),
            name: getDealerName(store.getState())
          }
        });
        /* eslint-enable camelcase */
      }
      break;
    }
    case actionTypesPersonInfo.SET_PERSON_INFO: {
      if (action.payload && action.payload.personId) {
        /* eslint-disable camelcase */
        pendo.identify({
          visitor: {
            id: `${getOrgKey(store.getState())}_${action.payload.personId}`
          },
          account: {
            id: 'xtm_' + getOrgKey(store.getState()),
            name: getDealerName(store.getState())
          }
        });
        /* eslint-enable camelcase */
      }
      break;
    }
    default:
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/pendo-middleware.js